var map = {
	"./1/title-banner1-type4.png": "RB+h",
	"./2/title-banner1-type4.png": "aS4a",
	"./3/title-banner1-type4.png": "PBLB",
	"./4/title-banner1-type4.png": "hypD",
	"./5/title-banner1-type4.png": "MtW3",
	"./6/title-banner1-type4.png": "dK6l",
	"./7/title-banner1-type4.png": "yPK5",
	"./8/title-banner1-type4.png": "ppOs"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Zx/o";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*\/title\-banner1\-type4\.png$
// module id = Zx/o
// module chunks = 1